import React from "react";
import {NavLink} from "react-router-dom";
import {Role, UserContext} from "../../controller/Utils";

export class DispatchHeaderLink extends React.Component {
  static contextType = UserContext;


  render() {
    const user = this.context.user;
    return (
      <ul className="nav justify-content-end top-submenu">
        <li>
          <NavLink activeClassName="active" to="/dashboard/live-map/">Live Map</NavLink></li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/routes/">Routes</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to="/dashboard/queue/">Queue</NavLink>
        </li>
        <li>
          <Role allow={['dispatcher']} isReverse={true} user={user}> <a>Routes Report</a></Role>
        </li>
      </ul>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/dispatch/DispatchHeaderLink.jsx